const initialState = {
  loading: false,
  success: false,
  error: null,
  response: null,
};

const userBulkUploadReducer = (state = initialState, action) => {
  switch (action.type) {
    case "USER_BULK_UPLOAD_REQUEST":
      return { ...state, loading: true, error: null, success: false };

    case "USER_BULK_UPLOAD_SUCCESS":
      return {
        ...state,
        loading: false,
        success: true,
        response: action.payload,
      };

    case "USER_BULK_UPLOAD_FAILURE":
      return {
        ...state,
        loading: false,
        success: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default userBulkUploadReducer;


